export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const RESET_CUSTOMERS = "RESET_CUSTOMERS";
export const SET_SPECIFIC_CUSTOMERS = "SET_SPECIFIC_CUSTOMERS";
export const RESET_SPECIFIC_CUSTOMERS = "RESET_SPECIFIC_CUSTOMERS";
